import React, { useState } from "react";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Button, Modal } from "semantic-ui-react";
import { connect } from "react-redux";
import PlanCardNew from "../layout/PlanCardNew";
import PlanCard from "../layout/PlanCard";
import "./PlanPrices.css";
import EditCard from "../layout/PlanCardEdit";

const PlanPrices = (props) => {
  const [newPlanInput, setNewPlanInput] = useState(false);
  const [editPlanInput, setEditPlanInput] = useState(false);
  const [plan, setPlan] = useState(null);
  const handleClose = () => {
    props.setOpen(false);
    setNewPlanInput(false);
  };
  const editPlan = (id) => {
    let plan;
    const plans = props.priceList.map((plan) => {
      let returnValue;
      if (plan.planId === id) returnValue = plan;
      return returnValue;
    });
    plans.forEach((p) => {
      if (p) plan = p;
    });
    setPlan(plan);
  };
  return (
    <Modal
      size={!newPlanInput ? "small" : "tiny"}
      onClose={handleClose}
      onOpen={() => props.setOpen(true)}
      open={props.open}
    >
      <Modal.Content scrolling className="eventVisitorModal">
        <div className="eventVisitorModalButton">
          <Button floated="left" circular icon="close" onClick={handleClose} />
          {newPlanInput || editPlanInput ? (
            <Button
              floated="right"
              circular
              color="black"
              basic
              content="Back"
              onClick={() =>
                newPlanInput
                  ? setNewPlanInput(false)
                  : setEditPlanInput(false) && setPlan(null)
              }
            />
          ) : (
            <Button
              icon="plus"
              floated="right"
              circular
              disabled={newPlanInput ? true : false}
              color="green"
              onClick={() => setNewPlanInput(true)}
            />
          )}
        </div>
        <div className="plan-data-section">
          {newPlanInput ? (
            <PlanCardNew callClose={() => setNewPlanInput(false)} />
          ) : editPlanInput ? (
            <EditCard
              plan={plan}
              callClose={() => {
                setEditPlanInput(false);
                setPlan(null);
              }}
            />
          ) : (
            <>
              <div className="PricePlanHead">
                <h3>Packages</h3>
              </div>
              <div className="PackageListing new-student-package">
                {props.priceList.length > 0 &&
                  props.priceList.map((price) => (
                    <PlanCard
                      plan={price}
                      key={price.planId}
                      editFlag={() => setEditPlanInput(true)}
                      editId={() => editPlan(price.planId)}
                    />
                  ))}
              </div>
            </>
          )}
        </div>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  let priceList = [];
  const priceListData = state.firestore.data.testPriceList;

  if (priceListData) {
    const keys = Object.keys(priceListData);
    keys.length > 0 &&
      keys.forEach((key) => priceList.push(priceListData[key]));
  }

  priceList = priceList
    .filter((price) => price && Object.keys(price).length > 0)
    .sort((a, b) => a.amount - b.amount);
  return {
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    priceList,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "testPriceList",
    },
  ])
)(PlanPrices);
